import Vue from 'vue';
import Router from 'vue-router';
import {
  verifyTestLessonToken,
  verifyLessonToken,
  verifyAdminTrainerLessonToken,
  verifyAccessToMaterial,
  verifyAccessToTrainerMaterial
} from '@/utils/verifyToken';
import logger from '@/modules/Logger';
import { verifyPageURL, verifyTrialLesson } from '@/utils/trialLesson';

const Lesson = () => import('@/views/Lesson');
const Error = () => import('@/views/Error');
const BrowserNotSupported = () => import('@/views/BrowserNotSupported');
const JwtError = () => import('@/views/JwtError');
const TrialLessonGenerator = () => import('@/views/TrialLessonGenerator');
const MaterialBuilder = () => import('@/views/MaterialBuilder');
const HtmlMaterial = () => import('@/views/HtmlMaterial');
const HtmlMaterialTrainer = () => import('@/views/HtmlMaterialTrainer');
const RedirectToHome = () => import('@/views/RedirectToHome');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH,
  routes: [
    {
      path: '*',
      component: Error
    },
    {
      path: '/error',
      name: 'Error',
      component: Error
    },
    {
      path: '/jwt-error',
      name: 'JwtError',
      component: JwtError
    },
    {
      path: '/redirect-to-home',
      name: 'RedirectToHome',
      component: RedirectToHome,
      beforeEnter: (to, from, next) => {
        logger.info(`Error page referrer: ` + from.path);
        logger.info(`Error page redirection to: ` + to.path);
        logger.info('Force sending of logs', { operation: 'send-batch-log' });
        next();
      }
    },
    {
      path: '/lesson/:lessonId',
      name: 'Lesson',
      component: Lesson,
      beforeEnter: (to, from, next) => verifyLessonToken(to, from, next)
    },
    {
      path: '/cms-preview/:lessonNo',
      name: 'CMSPreviewMaterial',
      component: Lesson,
      beforeEnter: (to, from, next) => verifyLessonToken(to, from, next)
    },
    {
      path: '/test-lesson/:lessonId',
      name: 'TestTrainer',
      component: Lesson,
      beforeEnter: (to, from, next) => verifyAdminTrainerLessonToken(to, from, next)
    },
    {
      path: '/trial-lesson-generator/:pageUrl',
      name: 'TrialLessonGenerator',
      component: TrialLessonGenerator,
      beforeEnter: (to, from, next) => verifyPageURL(to, from, next)
    },
    {
      path: '/trial-lesson/:lessonId/:pCompanyId/:hashCode/:user',
      name: 'TrialLessonPage',
      component: Lesson,
      beforeEnter: (to, from, next) => verifyTrialLesson(to, from, next)
    },
    {
      path: '/:lessonId/unsupported',
      name: 'BrowserNotSupported',
      component: BrowserNotSupported,
      beforeEnter: (to, from, next) => verifyLessonToken(to, from, next)
    },
    {
      path: '/:lessonId/assess-prod/:isStudent/:partnerId/:webrtcId',
      name: 'Assess',
      component: Lesson,
      beforeEnter: (to, from, next) => verifyTestLessonToken(to, from, next)
    },
    {
      path: '/material-builder/:rankId/:lessonId/:isCreate?',
      name: 'MaterialBuilder',
      component: MaterialBuilder
    },
    {
      path: '/html-material/:userTypeMaterial/:programId/:rankId/:lessonId/:revamp',
      name: 'HtmlMaterial',
      component: HtmlMaterial,
      beforeEnter: (to, from, next) => verifyAccessToMaterial(to, from, next)
    },
    {
      path: '/html-material/trainer/:programId/:rankId',
      name: 'TrainerHtmlMaterial',
      component: HtmlMaterialTrainer,
      beforeEnter: (to, from, next) => verifyAccessToTrainerMaterial(to, from, next)
    }
  ]
});

export default router;
